import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";

export default function NewsHighlights() {
  const [lead, ...rest] = newsList.slice(0, 5);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
      <Link
        to={`/news/${lead.id}`}
        className="group relative rounded-lg overflow-hidden border border-background-200 bg-background-50 card-hover"
      >
        <div className="relative w-full h-[220px] md:h-[300px]">
          <img
            src={lead.cover}
            alt={lead.title}
            title={`${lead.title} 影视资讯`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/30 to-transparent" />
          <div className="absolute top-3 left-3">
            <span className="px-2 py-0.5 rounded-md text-[11px] font-semibold bg-accent-500 text-background-50">
              {lead.category}
            </span>
          </div>
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <h3 className="text-base md:text-lg font-bold text-background-50 leading-snug line-clamp-2">
              {lead.title}
            </h3>
            <p className="text-xs text-background-200 mt-1.5 line-clamp-2">
              {lead.summary}
            </p>
          </div>
        </div>
      </Link>

      <ul className="flex flex-col gap-3">
        {rest.map((n) => (
          <li key={n.id}>
            <Link
              to={`/news/${n.id}`}
              className="group flex gap-3 md:gap-4 bg-background-50 border border-background-200 rounded-lg p-3 hover:border-primary-300 transition-colors"
            >
              <div className="w-24 md:w-32 h-16 md:h-20 rounded-md overflow-hidden bg-background-200 shrink-0">
                <img
                  src={n.cover}
                  alt={n.title}
                  title={`${n.title} 影视资讯`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {n.title}
                </h3>
                <div className="mt-1.5 flex items-center gap-2 text-[11px] text-foreground-500">
                  <span className="text-secondary-600 font-medium">{n.category}</span>
                  <span className="w-1 h-1 rounded-full bg-background-300" />
                  <span>{n.date}</span>
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}